// SavedPosts.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PostCard from "./PostCard";
import Header from "./Header";

const API_URL = process.env.REACT_APP_API_URL || 'https://pyate-backend-production-9749.up.railway.app';

const SavedPosts = () => {
  const [savedPosts, setSavedPosts] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setError("You must be logged in to view saved posts.");
        setLoading(false);
        return;
      }

      try {
        // First, fetch the user ID
        const userIdRes = await fetch(`${API_URL}/api/get-user-id`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!userIdRes.ok) throw new Error("Failed to fetch user ID");
        const userIdData = await userIdRes.json();
        const userId = userIdData.user_id;

        // Then fetch saved posts for this user
        const postsRes = await fetch(`${API_URL}/api/saved_posts_user`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!postsRes.ok) throw new Error("Failed to fetch saved posts");
        const postsData = await postsRes.json();
        setSavedPosts(postsData);
      } catch (err) {
        setError(err.message || "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <>
        <Header />
        <div style={styles.container}>Loading...</div>
      </>
    );
  }

  return (
    <>
      <Header /> 
      <div style={styles.container}>
        <h2>Saved Posts</h2>
        <button onClick={() => navigate(-1)} style={styles.backButton}>← Back</button>
        {error && <p style={styles.error}>{error}</p>}
        {savedPosts.length === 0 ? (
          <p>No saved posts found.</p>
        ) : (
          savedPosts.map((post) => (
            <PostCard key={post.postid} post={post} />
          ))
        )}
      </div>
    </>
  );
};

const styles = {
  container: {
    padding: "20px",
    maxWidth: "700px",
    margin: "80px auto",
    backgroundColor: "#fff",
    borderRadius: "8px",
    border: "1px solid #ddd",
    fontFamily: "Arial, sans-serif",
  },
  error: {
    color: "red",
  },
  backButton: {
    marginBottom: "20px",
    backgroundColor: "#ccc",
    border: "none",
    padding: "8px 12px",
    cursor: "pointer",
    borderRadius: "5px",
  }
};

export default SavedPosts;